var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.params.TextType,{tag:"component",attrs:{"params":_vm.params,"disabled":_vm.disabled,"language":_vm.language},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }